import React from "react";
import { Steps } from "primereact/steps";

export default function StepByStep({items, activeIndex}) {


  return (
    <>
      <Steps model={items} activeIndex={activeIndex} />
    </>
  );
}
